import type { StationState } from "@station-keeping/sim";
import type { ReactNode } from "react";
import { useGameUi } from "../../game/store";
import { useTutorial } from "../../game/tutorial";
import { formatClock, formatNumber, t } from "../../i18n";
import { Icon } from "../pixel";
import { Key, Plate, ScoreRow, SectionTitle } from "../primitives";
import { ProgressionSection } from "../Progression";

/** Le bilan de la station, lu comme un tableau des scores (et, plus bas, le compte du joueur). */
export function StationPanel({ state, children }: { state: StationState; children?: ReactNode }) {
  const openPanel = useGameUi((ui) => ui.openPanel);
  const startTutorial = useTutorial((tutorial) => tutorial.start);
  const stats = state.stats;
  return (
    <div>
      <Plate title={t("station.title")} onClose={() => openPanel(null)} />
      <ProgressionSection state={state} />
      <SectionTitle>{t("station.stats")}</SectionTitle>
      <dl>
        <ScoreRow label={t("station.stat.earned")} value={`${formatNumber(stats.creditsEarned)} CR`} />
        <ScoreRow label={t("station.stat.served")} value={formatNumber(stats.shipsServed)} tone="var(--color-good)" />
        <ScoreRow
          label={t("station.stat.partial")}
          value={formatNumber(stats.shipsPartial + stats.shipsUnserved)}
          tone={stats.shipsPartial + stats.shipsUnserved > 0 ? "var(--color-warn)" : undefined}
        />
        <ScoreRow label={t("station.stat.failures")} value={formatNumber(stats.failures)} />
        <ScoreRow label={t("station.stat.repairs")} value={formatNumber(stats.repairs + stats.patches)} />
        <ScoreRow label={t("station.stat.upgrades")} value={formatNumber(stats.upgrades)} />
        <ScoreRow label={t("station.stat.age")} value={formatClock(state.tick)} />
      </dl>
      <Key tone="quiet" size="sm" className="mt-4" onClick={() => startTutorial()}>
        <Icon name="replay" />
        {t("tutorial.replay")}
      </Key>
      {children}
    </div>
  );
}
